module.exports = __webpack_public_path__ + "img/qing.d70eb3bf.png";